import useAuth from '@hooks/useAuth'

const Log = props => {
  const { user } = useAuth()

  console.error('User', user)

  return props.content
}

class ErrorBoundary extends React.Component {
  public static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  public componentDidCatch(error, errorInfo) {
    console.error(error)
    console.error(errorInfo)
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Log content={this.props.content} />
    }

    return this.props.children
  }
}

ErrorBoundary.defaultProps = {
  content: 'Loading...',
}

export default ErrorBoundary
